module.exports = __webpack_public_path__ + "media/images/new-ui-images/icon-1-412ac134d42fb9672eacc48b29752bfd.svg";